import React, { useMemo } from 'react';
import { AVATAR_COLORS } from 'app/components/Avatar/constants';
import { AvatarBase } from './components';

interface Props {
  className?: string;
  email: string;
  firstName?: string;
  lastName?: string;
}

export default function Avatar({
  email,
  firstName,
  lastName,
  className,
}: Props) {
  const initials = useMemo(() => {
    let initials = '';

    if (firstName && lastName) {
      initials = `${firstName[0]}${lastName[0]}`;
    } else if (firstName) {
      initials = firstName[0];
    } else if (lastName) {
      initials = lastName[0];
    } else {
      initials = email[0];
    }

    return initials?.toUpperCase();
  }, [email, firstName, lastName]);

  const bgColor: string = useMemo(() => {
    if (!initials) {
      return AVATAR_COLORS[0];
    }

    return AVATAR_COLORS[initials[0]];
  }, [initials]);

  return <AvatarBase className={className} bgColor={bgColor} text={initials} />;
}
